import { MULTIPLE_USER_POWER_AGREEMENT } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPowerCommunityOrPPALease } = loanFormModel.formField;

class IsSystemPowerCommunityOrPPALeaseEqualTo implements Rule {
  private systemPowerCommunityOrPPALeaseValue: MULTIPLE_USER_POWER_AGREEMENT;

  public setValue(
    newSystemPowerCommunityOrPPALease: MULTIPLE_USER_POWER_AGREEMENT
  ) {
    this.systemPowerCommunityOrPPALeaseValue =
      newSystemPowerCommunityOrPPALease;
    return this;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const communityOrPPALease = application[
      systemPowerCommunityOrPPALease.name
    ] as MULTIPLE_USER_POWER_AGREEMENT | null;
    return communityOrPPALease === this.systemPowerCommunityOrPPALeaseValue;
  }
}

export default new IsSystemPowerCommunityOrPPALeaseEqualTo();
